import { apiFetch } from "./api";
import { stringifySnake } from "./serialization";

export function fetchDocuments(category, vehicleId) {
  const params = new URLSearchParams();
  if (category) params.set("category", category);
  if (vehicleId) params.set("vehicleId", vehicleId);
  const query = params.toString() ? `?${params.toString()}` : "";
  return apiFetch(`/api/v1/documents${query}`);
}

export function createDocument(payload) {
  return apiFetch("/api/v1/documents", {
    method: "POST",
    body: stringifySnake(payload),
  });
}

export function updateDocument(id, payload) {
  return apiFetch(`/api/v1/documents/${id}`, {
    method: "PATCH",
    body: stringifySnake(payload),
  });
}

export function deleteDocument(id) {
  return apiFetch(`/api/v1/documents/${id}`, { method: "DELETE" });
}

export function uploadDocumentFiles(id, files) {
  return apiFetch(`/api/v1/documents/${id}/files`, {
    method: "POST",
    body: stringifySnake({ files }),
  });
}

export function deleteDocumentFile(id, resourceId) {
  return apiFetch(`/api/v1/documents/${id}/files/${resourceId}`, {
    method: "DELETE",
  });
}
